// extracted by mini-css-extract-plugin
module.exports = {"keyWord":"keyWord_keyWord__2Rknx","keyWordItem":"keyWord_keyWordItem__3TGTF","keyWordIcon":"keyWord_keyWordIcon__oAlnl"};